// extracted by mini-css-extract-plugin
export default {"image":"Image_image__e6Efa","rounded":"Image_rounded__nmhfv"};